declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

let gtmUserId: string | number | undefined;

/** Синхронизируется из UserProvider (логин/логаут/восстановление сессии) — единая точка правды для user_id во всех dataLayer-событиях. */
export const setGtmUserId = (userId?: string | number | null) => {
  gtmUserId = userId ?? undefined;
};

export const pushDataLayerEvent = (payload: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...(gtmUserId !== undefined ? { user_id: gtmUserId } : {}),
    ...payload,
  });
};
